import notificationSettings from '@/locales/en/setting/notificationSettings.locales';
import occupations from '@/locales/en/setting/occupations.locales';
import overtime from '@/locales/en/setting/overtime.locales';
import procedures from '@/locales/en/setting/procedures.locales';
import products from '@/locales/en/setting/products.locales';
import structures from '@/locales/en/setting/structures.locales';

export default {
    ...notificationSettings,
    ...occupations,
    ...structures,
    ...overtime,
    ...products,
    ...procedures,
};
